<ng-container *ngIf="allowedSupporterRole((me$ | async)?.iotRole)">
  <ng-container *ngIf="invitationState$ | async as state">
    <ng-container *ngIf="state.loaded">
      <div class="installations-wrapper" [ngClass]="{ 'hide-results': !state.isData }">
        <h2 class="search-results-label">
          {{ '+SEARCH.RESULT_LIST.SEARCH_RESULT_INVITATIONS' | translate }}
        </h2>
        <div class="header-row" [class.with-scrollbar]="state.invitationsIds.length > 4">
          <div class="list-item-header flex flex-row justify-start items-center">
            <vi-dropdown
              data-at-event-type-filter
              class="flex-[18%] max-w-[18%]"
              [options]="statusFilters"
              [option]="initialFilter"
              width="80%"
              (optionChange)="onFilterChange($event)"
            >
            </vi-dropdown>
            <div class="header-row-item flex-[22%] max-w-[22%]">
              {{ 'GATEWAY.INVITATION_LIST.COLUMN.LAST_STATUS_CHANGE' | translate }}
            </div>
            <div class="header-row-item flex-[30%] max-w-[30%]">
              {{ 'GATEWAY.INVITATION_LIST.COLUMN.INVITER' | translate }}
            </div>
            <div class="header-row-item flex-[30%] max-w-[30%]">
              {{ 'GATEWAY.INVITATION_LIST.COLUMN.INVITEE' | translate }}
            </div>
          </div>
        </div>
        <ng-container *ngIf="state.isData">
          <app-infinite-scroll
            [state$]="invitationState$"
            [search$]="searchType$"
            [itemSize]="itemSize"
            (fetchNext)="onFetchNext($event)"
            [(nextBatch)]="nextBatch"
            (nextBatchChange)="onNextBatchChange($event)"
            [limit]="limit"
          >
            <cdk-virtual-scroll-viewport
              [style.height.px]="getViewportHeight(state.invitationsIds.length, itemSize, 0)"
              class="cdk-virtual-scroll-viewport-invitations"
              [itemSize]="itemSize"
            >
              <div *cdkVirtualFor="let token of state.invitationsIds" class="list-item-invitations">
                <app-invitation-list-item
                  class="flex flex-row"
                  [invitation]="state.invitations[token]"
                  [inviter]="state.inviterDetails[state.invitations[token].inviterAccount]"
                  [invitee]="state.inviteeDetails[state.invitations[token].inviteeAccount]"
                  [inviteeCompany]="
                    state.inviteeCompanyDetails[state.invitations[token].customerNumber]
                  "
                  [inviterCompany]="
                    state.inviterCompanyDetails[state.invitations[token].inviterCustomerNumber]
                  "
                ></app-invitation-list-item>
              </div>
              <vi-loader
                *ngIf="nextBatch"
                [isLoading]="true"
                [message]="'+SEARCH.RESULT_LIST.FETCHING_MORE_RESULTS' | translate"
              ></vi-loader>
            </cdk-virtual-scroll-viewport>
          </app-infinite-scroll>
        </ng-container>
        <ng-container *ngIf="!state.isData">
          <div class="no-results">{{ 'GATEWAY.INVITATION_LIST.NO_RESULTS' | translate }}</div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
